export default __webpack_public_path__ + "media/src/assets/images/tender-fdd255e333abf84811bdf47813b73d74.png";